import type { RequestFormValues } from 'legal/types/requestFormTypes'

const DEFAULT_SUBJECT = 'Privacy Rights Request'

const formatDescription = (
	category: string,
	state: string,
	message: string
): string =>
	`Privacy Right Category: ${category}\nState of residence: ${state}\nMessage: ${message}`

export const formatPrivacyFormRequest = (values: RequestFormValues) => {
	const { firstName, lastName, email, state, message, category } = values

	return {
		subject: DEFAULT_SUBJECT,
		description: formatDescription(category, state, message),
		firstName,
		lastName,
		email,
	}
}
